import React, { FC } from "react";
import { combineSlugId } from "src/utils/combineSlugId";
import { getItemPath } from "src/utils/getItemPath";
import { PATHNAMES } from "src/constants/routes";
import { Image } from "./Image";
import { ReadingTime } from "./ReadingTime";
import { Date } from "./Date";
import { IBlogCard } from "./types";
import { Link } from "../Link";

export const BlogCard: FC<IBlogCard> = ({
  id,
  image,
  category,
  read_time,
  date,
  slug,
  title,
  short_description,
}) => {
  const combinedSlug = combineSlugId(slug, id);
  const blogItemPath = getItemPath(PATHNAMES.BLOG_ITEM, { slug: combinedSlug });

  return (
    <article className="flex flex-col md:flex-row border rounded-20 xl:max-w-200">
      <Image
        path={blogItemPath}
        image={image}
        category={category.title}
        alt={title}
      />

      <div className="flex flex-col gap-4 w-full px-5 py-3 md:py-5">
        <div className="flex sm:flex-col lg:flex-row gap-5 justify-between">
          <ReadingTime read_time={read_time} />
          <Date date={date} />
        </div>

        <Link href={blogItemPath}>
          <h4
            className="line-clamp-1 hover:text-purple-base hover:underline"
            title={title}
          >
            {title}
          </h4>
        </Link>

        <div
          className="line-clamp-4"
          dangerouslySetInnerHTML={{ __html: short_description }}
        />
      </div>
    </article>
  );
};
